import { MovieFreeGLightbox } from "../common/image_gallery";
import { mbSocialSharing, socialSharing } from "../common/sharing";
import {
	CmpCheck,
	loadScript,
	trackLinkEvent,
	yieldToMainBackground,
} from "../common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// invio evento onclick sui "leggi anche" nel testo
	for (const link of document.querySelectorAll(
		".article__content__leggi-anche a",
	)) {
		link.addEventListener("click", () => {
			yieldToMainBackground().then(() => {
				trackLinkEvent("read-more-link");
			});
		});
	}

	// invio evento onclick sui "leggi anche" in sidebar
	for (const link of document.querySelectorAll("a._related_articles")) {
		link.addEventListener("click", () => {
			yieldToMainBackground().then(() => {
				trackLinkEvent("related-content-link");
			});
		});
	}

	// galleria immagini
	for (const el of document.querySelectorAll("._article_gallery")) {
		new MovieFreeGLightbox({
			selector: el.dataset.gallerySelector,
		});
	}

	// Galleria lightbox per le immagini singole
	const images = [];
	document.querySelectorAll(".galleria_single img").forEach((el, index) => {
		images.push({ href: el.dataset.gallerySrc, title: el.dataset.caption });
		el.dataset.galleryIndex = index;
	});
	const article_gallery = new MovieFreeGLightbox({
		elements: images,
		selector: ".galleria_single img",
	});

	if (document.querySelector(".social-share")) {
		// Social
		const fb = new socialSharing(
			document.querySelector(".social-share .social-facebook-share"),
			{ kind: "facebook" },
		);
		const x = new socialSharing(
			document.querySelector(".social-share .social-X-share"),
			{ kind: "x", suffix: "via @movieplayer_it" },
		);
		const tg = new socialSharing(
			document.querySelector(".social-share .social-telegram-share"),
			{ kind: "telegram" },
		);
		const wa = new socialSharing(
			document.querySelector(".social-share .social-whatsapp-share"),
			{ kind: "whatsapp" },
		);
	}
	const mb_share = document.querySelector("#_share-mb");
	if (mb_share) {
		mb_share.addEventListener("click", (event) => {
			event.preventDefault();
			mbSocialSharing(mb_share);
		});
	}

	// article index
	const article_index = document.querySelector("#_article_index");
	if (article_index) {
		for (const el of document.querySelectorAll("._index_toggle")) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				article_index.classList.toggle("closed");
				const label = el.querySelector("#_index_label");
				if (label) {
					if (label.textContent === "Mostra di più") {
						label.textContent = "Mostra di meno";
					} else {
						label.textContent = "Mostra di più";
					}
				}
			});
		}
	}
	// Social embeds
	document.addEventListener("lazybeforeunveil", (event) => {
		const target = event.target;
		if (target.classList.contains("_tw_embed")) {
			// Twitter embeds
			const cmp = new CmpCheck();
			cmp.checkConsent().then((response) => {
				if (response) {
					// biome-ignore lint/complexity/useArrowFunction: twitter code
					window.twttr = (function (d, s, id) {
						const fjs = d.getElementsByTagName(s)[0];
						const t = window.twttr || {};
						if (d.getElementById(id)) return t;
						const js = d.createElement(s);
						js.id = id;
						js.src = "https://platform.twitter.com/widgets.js";
						fjs.parentNode.insertBefore(js, fjs);
						t._e = [];
						// biome-ignore lint/complexity/useArrowFunction: twitter code
						t.ready = function (f) {
							t._e.push(f);
						};
						return t;
					})(document, "script", "twitter-wjs");

					twttr.ready((twttr) => {
						const tweetError = target.querySelector("._tw_error");
						twttr.widgets
							.createTweet(target.dataset.id, target)
							.then((data) => {
								if (typeof data === "undefined") {
									tweetError.classList.remove("d-none");
									tweetError.classList.add("d-flex");
								}
							})
							.catch((error) => {
								tweetError.classList.remove("d-none");
								tweetError.classList.add("d-flex");
							});
					});
				}
			});
		} else if (target.classList.contains("_ig_embed")) {
			const cmp = new CmpCheck();
			cmp.checkConsent().then((response) => {
				if (response) {
					loadScript(
						"instagram-js",
						"https://www.instagram.com/static/bundles/metro/EmbedSDK.js/33cd2c5d5d59.js",
					)
						.then(() => {
							target.innerHTML = JSON.parse(
								target.querySelector("script").textContent,
							).embed;
							instgrm.Embeds.process();
						})
						.catch((error) => {
							console.warn(" --- Error: ", error);
						});
				}
			});
		}
	});
});
